import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import ContactContext from 'contexts/contactContext'
import getIsLoyaltyPrioritySupportNumberEnabled from 'loyalty/selectors/getIsLoyaltyPrioritySupportNumberEnabled'
import { useAppSelector } from 'hooks/reduxHooks'

const image: App.Image = {
  id: 'kf3r6fahlubu2yb1htkgb',
  title: 'Faster, priority support',
}

interface Props {
  tier: App.LoyaltyTier
}

function LandingPageLoyaltyPhoneSupport(props: Props) {
  const { tier } = props
  const contact = useContext(ContactContext)
  const isLoyaltyPrioritySupportNumberEnabled = useAppSelector(getIsLoyaltyPrioritySupportNumberEnabled)
  const intl = useIntl()
  const benefitAction = useMemo(() => {
    if (!isLoyaltyPrioritySupportNumberEnabled) return
    return <TextButton kind="secondary" href={`tel:${contact.local.number}`} startIcon={<LinePhoneIcon />}>
      {contact.local.humanReadable}
    </TextButton>
  }, [isLoyaltyPrioritySupportNumberEnabled, contact.local.number, contact.local.humanReadable])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'b_SqNKqoZndakuOZSzqQ',
      defaultMessage: 'Faster, priority support',
      description: 'Heading for loyalty priority phone support benefit tile',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{intl.formatMessage({
      id: '1SmEIdpWHiwMRSfBDeXo',
      defaultMessage: 'All year round',
      description: 'Label indicating priority support is available all year round',
    })}
    </LoyaltyTierLabel>}
    image={image}
    actions={benefitAction}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'YOg7LCD3gKJcvgPGHQKa',
        defaultMessage: 'Skip the queue. Our dedicated support team is just a call away, any time of day or night, with faster response times and help when you need it most.',
        description: 'Description of the priority phone support loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyPhoneSupport
